(function () {
  'use strict';

  angular.module('ringbaPortal').config(function (
    _,
    $stateProvider,
    $urlRouterProvider,
    $httpProvider,
    logEnhancerProvider,
    localStorageServiceProvider,
    appStoragesProvider,
  ) {

    $httpProvider.interceptors.push('authInterceptorService');
    $httpProvider.interceptors.push('apiUrlInterceptor');

    localStorageServiceProvider.setPrefix(appStoragesProvider.prefix);

    logEnhancerProvider.prefixPattern = '%s::[%s]>';
    logEnhancerProvider.datetimePattern = 'MM/DD/YY h:mm:ss a';

    function accountIdResolve(accountsService, authService, featureFlagsService, supportChatService, systemFlagsService) {
      authService.fillAuthData();

      return accountsService.loadAccountsData().then(function () {
        try {
          supportChatService.reauthenticate();
        } catch {
          // Do nothing if exception is caught
        }
        featureFlagsService.disableAllFeatureFlags();

        return featureFlagsService.setFeatureFlags(accountsService.currentAccountId);
      }).then(function () {
        return systemFlagsService.whenSettled();
      });
    }

    function getTemplateId($stateParams) {
      return $stateParams.templateId;
    }

    function getPredictiveRoutingId($stateParams) {
      return $stateParams.configId;
    }

    function getTreeId($stateParams) {
      return $stateParams.treeId;
    }

    function joinInviteResolve($stateParams, authService, invitesService) {
      const inviteId = $stateParams.inviteId;
      return invitesService.checkInviteStatus(inviteId).then(function (response) {
        const status = response.data.status;
        if (status.userExists) {
          authService.fillAuthData();
          status.isUserLoggedIn = !!authService.authentication.isAuth;
        }
        return status;
      }).catch(function (err) {
        const status = {};
        if (err.status === 404) {
          status.inviteNotFound = true;
        } else {
          status.isTechnicalError = true;
        }
        if ($stateParams.preview) {
          status.isInvitationValid = true;
        }
        return status;
      });
    }

    function prpResolve($stateParams, authService, publisherRegistrationService) {
      if ($stateParams.preview) {
        return {
          accountName: 'acc1',
          description: '[Publisher Registration Description goes here]',
          contactEmail: 'test-email@your-email-server.com',
          termsAndConditions: 'Sample Terms and Conditions',
          isTermsAndConditionsURL: false,
          requireAgreementToTerms: true,
        };
      }

      // Super simple logic
      return publisherRegistrationService.getPublicPRPDetails($stateParams.prpId).then(function (response) {
        return response.data;
      }).catch(function () {
        return null;
      });
    }

    function brpResolve($stateParams, authService, buyerRegistrationService) {
      if ($stateParams.preview) {
        return {
          accountName: 'acc1',
          description: '[Buyer Registration Description goes here]',
          contactEmail: 'test-email@your-email-server.com',
          termsAndConditions: 'Sample Terms and Conditions',
          isTermsAndConditionsURL: false,
          requireAgreementToTerms: true,
        };
      }

      // Super simple logic
      return buyerRegistrationService.getPublicBRPDetails($stateParams.brpId).then(function (response) {
        return response.data;
      }).catch(function () {
        return null;
      });
    }

    function savedReportSettingsResolve($stateParams, accountsService, savedReportService) {
      return savedReportService.getReport(accountsService.currentAccountId, $stateParams.reportId)
        .catch(function (response) { return response; }); // Don't block transition, this is only to preload.
    }

    function callLogsTemplateProvider() {
      'ngInject';

      return '<call-log-vue-container></call-log-vue-container>';
    }

    if (__BUILD_CONFIG__.routes.demo != null) {
      $stateProvider.state('dashboard.v3', {
        url: '/demo',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'demo\'" fallback />',
          },
        },
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'auth',
        }
      });
    }

    if (__BUILD_CONFIG__.routes.recordings != null) {
      $stateProvider.state('dashboard.recording-access', {
        url: '/recording-access',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'recordings\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        },
      });
    }

    if (__BUILD_CONFIG__.routes.outboundPingInsights != null) {
      $stateProvider.state('dashboard.outbound-ping-http-failures', {
        url: '/insights/outbound-ping-http-failures',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'outboundPingInsights\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'CallLog',
            permission: 'READ'
          }
        },
      });
    }

    if (__BUILD_CONFIG__.routes.numberPoolSummary != null) {
      $stateProvider.state('dashboard.number-pool-summary', {
        url: '/insights/number-pool-summary',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'numberPoolSummary\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
        },
      });
    }

    if (__BUILD_CONFIG__.routes.rtbSummary != null) {
      $stateProvider.state('dashboard.inbound-bid-requests', {
        url: '/insights/inbound-bid-requests',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'rtbSummary\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
        },
      });
    }

    if (__BUILD_CONFIG__.routes.outboundBidRequests != null) {
      $stateProvider.state('dashboard.outbound-bid-requests', {
        url: '/insights/outbound-bid-requests',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'outboundBidRequests\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'CallLog',
            permission: 'READ'
          }
        },
      });
    }

    if (__BUILD_CONFIG__.routes.rtbBillingInsights != null) {
      $stateProvider.state('dashboard.rtb-billing-insights', {
        url: '/billing-settings/rtb-billing',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'rtbBillingInsights\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
        },
      });
    }

    if (__BUILD_CONFIG__.routes.ringTreeAdvancedSettings != null) {
      $stateProvider.state('dashboard.ring-tree-advanced-settings', {
        url: '/ring-trees/advanced-settings',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'ringTreeAdvancedSettings\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        },
      });
    }

    if (__BUILD_CONFIG__.routes.transcription != null) {
      $stateProvider.state('dashboard.transcription', {
        url: '/transcription/:callId',
        views: {
          'main@dashboard': {
            template: '<vue-redirect-to-v3 flag="\'transcription\'" fallback />',
          },
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
        },
      });
    }

    $stateProvider
      .state('logout', {
        url: '/logout',
        controller: 'LogoutController',
        data: {
          requireAuth: true,
        }
      })

      .state('oauth', {
        url: '/oauth',
        controller: 'OAuthController',
        data: {
          requireAuth: true,
          requireAccount: true, // Need this !!
          redirectAfterLogin: true
        }
      })

      .state('login', {
        // 'invited', 'fname' & 'nuser'(new user) query params are to be used only when user comes from the invite page
        // and when an existing user ends up on the invite page
        url: '/login?invited&fname&nuser&preview&passResetRequested',
        template: '<login-v2></login-v2>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth',
          cssClassNames: 'fill_height',
          redirectIfAuthed: true
        }
      })

      // Login-time Terms & Conditions gate. Top-level (not under `dashboard`) so it renders
      // chrome-less; enforcement lives in statePermissionService (app.js transition hook).
      // Wrapped in <vue-redirect-to-v3> so the V3 page owns the gate when `portal_v3` is on;
      // otherwise the inline V2 fallback (<vue-terms-gate>) renders. The fallback is a Vue
      // component like every other <vue-redirect-to-v3> slot — raw AngularJS content (e.g.
      // ng-include) can't render inside the ngVue-managed slot.
      //
      // URL lives under `/dashboard/` even though this is top-level: the dev proxy only routes
      // `/dashboard/*` to V3, and V3 serves this at `/dashboard/terms` (base `/dashboard/` + `/terms`).
      // A bare `/terms` would proxy back to V2 and loop forever.
      .state('terms', {
        url: '/dashboard/terms',
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'unauth',
          cssClassNames: 'fill_height'
        },
        resolve: {
          // Populate `currentAccountFeatureFlags` before the gate renders, so <vue-redirect-to-v3> can read `portal_v3`.
          // This top-level state skips `accountIdResolve`, so it loads the account here.
          __featureFlags: /* @ngInject */ function(accountsService, featureFlagsService, systemFlagsService) {
            return accountsService.loadAccountsData().then(function() {
              return featureFlagsService.setFeatureFlags(accountsService.currentAccountId);
            }).then(function() {
              return systemFlagsService.whenSettled();
            });
          }
        },
        template:
          '<vue-redirect-to-v3 flag="\'terms\'">' +
          '<vue-terms-gate></vue-terms-gate>' +
          '</vue-redirect-to-v3>'
      })

      .state('sso', {
        url: '/sso',
        abstract: true,
        data: {
          redirectAfterLogin: true,
          requireAuth: true,
          requireAccount: true,
        }
      })

      .state('sso.zendesk', {
        url: '/zendesk?return_to',
        controller: 'ZendeskSSOController',
        template: '<zendesk></zendesk>',
        data: {
          redirectAfterLogin: true
        }
      })

      .state('signup', {
        url: '/signup',
        template: '<tr-signup></tr-signup>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth',
          cssClassNames: 'fill_height',
          redirectIfAuthed: true
        }
      })

      .state('join', {
        url: '/join?:t&u',
        template: '<tr-join></tr-join>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth'
        }
      })

      .state('join-invite', {
        url: '/invite/:inviteId?fname&lname&preview&flow&pubname&account&buyername',
        template: '<join-invite-v2 invite-status="$resolve.inviteStatus"></join-invite-v2>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth',
          cssClassNames: 'fill_height'
        },
        resolve: {
          inviteStatus: joinInviteResolve
        }
      })

      .state('prp-register', {
        url: '/publisher-registration/:prpId?preview',
        template: '<prp-v2 prp-details="$resolve.prpDetails"></prp-v2>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth',
          cssClassNames: 'fill_height'
        },
        resolve: {
          prpDetails: prpResolve
        }
      })

      .state('brp-register', {
        url: '/buyer-registration/:brpId?preview',
        template: '<brp brp-details="$resolve.brpDetails"></brp>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth',
          cssClassNames: 'fill_height'
        },
        resolve: {
          brpDetails: brpResolve
        }
      })

      .state('pw', {
        url: '/pw?:t&u&preview',
        template: '<reset-password-v2></reset-password-v2>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth'
        }
      })

      .state('forgot-password', {
        url: '/forgot-password?preview',
        template: '<forgot-password-v2></forgot-password-v2>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth',
          cssClassNames: 'fill_height',
          redirectIfAuthed: true
        }
      })

      .state('reset-password', {
        url: '/reset-password?:t&u&preview',
        template: '<reset-password-v2></reset-password-v2>',
        data: {
          requireAuth: false,
          requireAccount: false,
          view: 'unauth'
        }
      })

      .state('dashboard', {
        url: '/dashboard',
        abstract: true,
        template: '<tr-dashboard-layout></tr-dashboard-layout>',
        resolve: {
          __accountId: accountIdResolve
        }
      })

      .state('dashboard.billing-settings', {
        url: '/billing-settings',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'billingSettings'"><vue-billing-settings /></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.account-details', {
        url: '/account-details',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'accountDetails'"><vue-account-details /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })


      .state('dashboard.account-settings', {
        url: '/account-settings',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'accountSettings'"><vue-account-settings /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.bulk-tags', {
        url: '/bulk-tags',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'bulkTags'"><bulk-tags></bulk-tags></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.activity-feed', {
        url: '/activity-feed',
        views: {
          'main@dashboard': {
            template: '<tr-activity-feed></tr-activity-feed>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.predictive-routing', {
        url: '/predictive-routing',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'predictiveRouting'"><predictive-routing configId="$resolve.configId"></predictive-routing></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        },
        params: {
          configId: {
            dynamic: true,
            value: null,
            squash: true
          }
        },
        resolve: {
          configId: getPredictiveRoutingId
        }
      })

      .state('dashboard.predictive-routing-details', {
        url: '/predictive-routing/edit/:configId',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'predictiveRouting'"><predictive-routing configId="$resolve.configId"></predictive-routing></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        },
        params: {
          configId: {
            dynamic: true,
            value: null
          }
        },
        resolve: {
          configId: getPredictiveRoutingId
        },
      })

      .state('dashboard.user-profile', {
        url: '/user-profile',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'userProfile'"><vue-user-profile /></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
        }
      })

      .state('dashboard.api-tokens', {
        url: '/api-tokens',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'apiTokens'"><vue-api-tokens /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
        }
      })

      .state('dashboard.multi-factor-auth', {
        url: '/multi-factor-auth',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'mfa'"><vue-two-factor-auth /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
        }
      })

      .state('dashboard.rate-limits', {
        url: '/rate-limits',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'rateLimits'"><vue-rate-limits></vue-rate-limits></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
        }
      })

      .state('dashboard.whitelabel-settings', {
        url: '/whitelabel-settings?cname',
        views: {
          'main@dashboard': {
            template: '<whitelabel-settings></whitelabel-settings>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.login-security', {
        url: '/login-security',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'loginSecurity'"><vue-login-history /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
        }
      })

      .state('dashboard.prp-settings', {
        url: '/publisher-registration',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'publisherRegistration'"><vue-publisher-registration-settings /></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.brp-settings', {
        url: '/buyer-registration',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'buyerRegistration'"><vue-buyer-registration-settings /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: false,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.main', {
        url: '/main',
        cache: false,
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'dashboard'"><tr-dashboard></tr-dashboard></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          cssClassNames: 'dashboard-main',
          permission: {
            type: 'Dashboard',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.tcpa-shield', {
        url: '/tcpa-shield',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'tcpaShield'"><tcpa-shield-billing></tcpa-shield-billing></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.tcpa-shield.billing', {
        url: '/tcpa-shield/billing',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'tcpaShield'"><tcpa-shield-billing></tcpa-shield-billing></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.tcpa-shield.usage', {
        url: '/tcpa-shield/usage',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'tcpaShield'"><tcpa-shield-usage></tcpa-shield-usage></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.tcpa-shield.file', {
        url: '/tcpa-shield/file',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'tcpaShield'"><tcpa-shield-file-upload></tcpa-shield-file-upload></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.affiliates', {
        url: '/affiliates',
        views: {
          'main@dashboard': {
            template: '<vue-publishers></vue-publishers>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Affiliate',
            permission: 'READ'
          }
        }
      })
      .state('dashboard.affiliate', {
        url: '/affiliate',
        abstract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Affiliate',
            permission: 'UPDATE'
          }
        }
      })

      .state('dashboard.affiliate.edit', {
        url: '/:affiliateId',
        template: '<vue-publishers></vue-publishers>',
      })

      .state('dashboard.insights.default', {
        url: '/default?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container></insights-vue-container>',
          }
        },
        data: {
          selectedGroupBys: [{ field: 'campaignName', displayName: 'Campaign' }],
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.insights.admin-profit-and-cost', {
        url: '/admin-profit-and-cost?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'callLengthInSeconds',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'earningsPerCallGross',
              'profitMarginGross',
              'telcoCost',
              'dataEnrichmentCount',
              'icpCost',
              'totalCost',
              'profitNet',
              'earningsPerCallNet',
              'profitMarginNet'
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Profit and cost analysis',
          selectedGroupBys: [
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'Today'
        }
      })
      .state('dashboard.insights.last-month-by-day', {
        url: '/last-month-by-day?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'connectedCallCount',
              'nonConnectedCallCount',
              'convertedCalls',
              'payoutCount',
              'duplicateCalls',
              'blockedCalls',
              'convertedPercent',
              'nonConnectedPercent',
              'blockedPercent',
              'callLengthInSeconds',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'earningsPerCallGross',
              'profitMarginGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Last month by day',
          selectedGroupBys: [
            {
              field: 'tag:Date:UTCDay',
              displayName: 'Date:UTCDay'
            },
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'Last month'
        }
      })

      .state('dashboard.insights.this-month-by-day', {
        url: '/this-month-by-day?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'connectedCallCount',
              'nonConnectedCallCount',
              'convertedCalls',
              'payoutCount',
              'duplicateCalls',
              'blockedCalls',
              'convertedPercent',
              'nonConnectedPercent',
              'blockedPercent',
              'callLengthInSeconds',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'earningsPerCallGross',
              'profitMarginGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'This month by day',
          selectedGroupBys: [
            {
              field: 'tag:Date:UTCDay',
              displayName: 'Date:UTCDay'
            },
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'This month'
        }
      })

      .state('dashboard.insights.adjustments-last-month', {
        url: '/adjustments-last-month?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'convertedCalls',
              'convAdjustmentRequestCount',
              'convAdjustmentsApproved',
              'convAdjustmentsRejectedCount',
              'payoutAdjustedCalls',
              'conversionAdjustedCalls',
              'convAdjustmentsApprovedAmount',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Buyer adjustments last month',
          selectedGroupBys: [
            {
              field: 'targetName',
              displayName: 'Target'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'Last month'
        }
      })

      .state('dashboard.insights.adjustments-this-month', {
        url: '/adjustments-this-month?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'convertedCalls',
              'convAdjustmentRequestCount',
              'convAdjustmentsApproved',
              'convAdjustmentsRejectedCount',
              'payoutAdjustedCalls',
              'conversionAdjustedCalls',
              'convAdjustmentsApprovedAmount',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Buyer adjustments this month',
          selectedGroupBys: [
            {
              field: 'targetName',
              displayName: 'Target'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'This month'
        }
      })

      .state('dashboard.insights.target-profitability', {
        url: '/target-profitability?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },

        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'payoutCount',
              'duplicateCalls',
              'convertedCalls',
              'blockedCalls',
              'nonConnectedCallCount',
              'convertedPercent',
              'blockedPercent',
              'nonConnectedPercent',
              'connectedCallLengthInSeconds',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'earningsPerCallGross',
              'profitMarginGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Target Profitability',
          selectedGroupBys: [
            {
              field: 'targetName',
              displayName: 'Target'
            },
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
            {
              field: 'publisherName',
              displayName: 'Publisher'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'Today'
        }
      })

      .state('dashboard.insights.pub-last-month-profitability', {
        url: '/pub-last-month-profitability?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'convertedCalls',
              'payoutCount',
              'duplicateCalls',
              'blockedCalls',
              'convertedPercent',
              'blockedPercent',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'profitMarginGross',
              'earningsPerCallGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Last month\'s publisher profitability',
          selectedGroupBys: [
            {
              field: 'publisherName',
              displayName: 'Publisher'
            },
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
            {
              field: 'targetName',
              displayName: 'Target'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'Last month'
        }
      })

      .state('dashboard.insights.pub-last-week-profitability', {
        url: '/pub-last-week-profitability?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'convertedCalls',
              'payoutCount',
              'duplicateCalls',
              'blockedCalls',
              'convertedPercent',
              'blockedPercent',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'profitMarginGross',
              'earningsPerCallGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Last week\'s publisher profitability',
          selectedGroupBys: [
            {
              field: 'publisherName',
              displayName: 'Publisher'
            },
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
            {
              field: 'targetName',
              displayName: 'Target'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'Last week'
        }
      })

      .state('dashboard.insights.pub-this-month-profitability', {
        url: '/pub-this-month-profitability?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'convertedCalls',
              'payoutCount',
              'duplicateCalls',
              'blockedCalls',
              'convertedPercent',
              'blockedPercent',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'profitMarginGross',
              'earningsPerCallGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'This month\'s publisher profitability',
          selectedGroupBys: [
            {
              field: 'publisherName',
              displayName: 'Publisher'
            },
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
            {
              field: 'targetName',
              displayName: 'Target'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'This month'
        }
      })

      .state('dashboard.insights.pub-today-profitability', {
        url: '/pub-today-profitability?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container column-state="$resolve.columnState"></insights-vue-container>',
          }
        },
        resolve: {
          columnState: function (cannedReportsService) {
            'ngInject';

            return cannedReportsService.getColumnState([
              'callCount',
              'convertedCalls',
              'payoutCount',
              'duplicateCalls',
              'blockedCalls',
              'convertedPercent',
              'blockedPercent',
              'conversionAmount',
              'payoutAmount',
              'profitGross',
              'profitMarginGross',
              'earningsPerCallGross',
            ], [{
              colId: 'ag-Grid-AutoColumn',
              sort: 'asc'
            }]);
          }
        },
        data: {
          title: 'Today\'s publisher profitability',
          selectedGroupBys: [
            {
              field: 'publisherName',
              displayName: 'Publisher'
            },
            {
              field: 'campaignName',
              displayName: 'Campaign'
            },
            {
              field: 'targetName',
              displayName: 'Target'
            },
          ],
          initialExpandAllGroups: false,
          quickDateRangeSelector: 'Today'
        }
      })

      .state('dashboard.insights.publisher', {
        url: '/publisher',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container></insights-vue-container>',
          }
        },
        data: {
          selectedGroupBy: { field: 'publisherName', displayName: 'Publisher' }
        }
      })

      .state('dashboard.insights.target', {
        url: '/target',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container></insights-vue-container>',
          }
        },
        data: {
          selectedGroupBy: { field: 'targetName', displayName: 'Target' }
        }
      })

      .state('dashboard.insights.campaign', {
        url: '/campaign',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container></insights-vue-container>',
          }
        }
      })

      .state('dashboard.insights.viewInsight', {
        url: '/:insightId?source',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container ></insights-vue-container>',
          }
        }
      })

      .state('dashboard.event-insights', {
        url: '/event-insights',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'targetDialInsights'"><vue-event-insights /></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.campaigns', {
        url: '/campaigns',
        views: {
          'main@dashboard': {
            template: '<tr-campaigns></tr-campaigns>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Campaign',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.campaign', {
        url: '/campaign/:campaignId?showOffer&showRequests',
        views: {
          'main@dashboard': {
            template: '<tr-campaign></tr-campaign>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Campaign',
            permission: 'READ'
          }
        },
        resolve: {
          userSettings: function (userSettingsService) {
            // This will cache the user settings, in case it has not been cached already
            // This will avoid delay in showing the Next steps panel
            return userSettingsService.getUserSettings();
          }
        }
      })

      .state('dashboard.campaign-wizard', {
        url: '/campaign-wizard/:campaignId',
        views: {
          'main@dashboard': {
            template: '<tr-campaigns></tr-campaigns>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Campaign',
            permission: 'CREATE'
          }
        },
        params: {
          campaignId: {
            dynamic: true,
            value: null,
            squash: true
          },
          isDuringSetup: {
            dynamic: true,
            value: false,
            squash: true
          }
        }
      })

      .state('dashboard.ivrs', {
        url: '/ivrs',
        views: {
          'main@dashboard': {
            template: '<ivrs></ivrs>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'IVR',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.ivr', {
        url: '/ivr',
        abstract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth'
        }
      })

      .state('dashboard.ivr.new', {
        url: '/:treeId',
        template: '<ivr></ivr>',
        data: {
          permission: {
            type: 'IVR',
            permission: 'CREATE'
          }
        },
        params: {
          treeId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.ivr.new.template', {
        url: '/template/:templateId',
        template: '<ivr></ivr>',
        data: {
          permission: {
            type: 'IVR',
            permission: 'CREATE'
          }
        },
        params: {
          templateId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.ivr.edit', {
        url: '/edit/:treeId',
        template: '<ivr></ivr>',
        data: {
          permission: {
            type: 'IVR',
            permission: 'UPDATE'
          }
        }
      })
      .state('dashboard.ivr.assets', {
        url: '/assets',
        template: '<ivr-assets></ivr-assets>',
        data: {
          permission: {
            type: 'IVR',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.call-flows', {
        url: '/call-flows',
        views: {
          'main@dashboard': {
            template: '<call-flows></call-flows>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'IVR',
            permission: 'READ'
          }
        }
      })
      .state('dashboard.call-flow', {
        url: '/call-flow',
        abstract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth'
        }
      })
      .state('dashboard.call-flow.create', {
        url: '/create',
        template: '<call-flow></call-flow>',
        data: {
          permission: {
            type: 'IVR',
            permission: 'CREATE'
          }
        }
      })
      .state('dashboard.call-flow.template', {
        url: '/template/:templateId',
        template: '<call-flow templateId="$resolve.templateId"></call-flow>',
        data: {
          permission: {
            type: 'IVR',
            permission: 'CREATE'
          },
        },
        params: {
          templateId: {
            dynamic: true,
            value: null,
            squash: true
          }
        },
        resolve: {
          templateId: getTemplateId
        }
      })
      .state('dashboard.call-flow.edit', {
        url: '/edit/:treeId',
        template: '<call-flow treeId="$resolve.treeId"></call-flow>',
        data: {
          permission: {
            type: 'IVR',
            permission: 'CREATE'
          }
        },
        params: {
          treeId: {
            dynamic: true,
            value: null,
            squash: true
          }
        },
        resolve: {
          treeId: getTreeId
        }
      })

      .state('dashboard.numbers', {
        url: '/numbers',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'numbers'"><vue-numbers-list></vue-numbers-list></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Number',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.numbers.edit', {
        url: '/edit/:numberId',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'numbers'"><vue-numbers-list></vue-numbers-list></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Number',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.blocked-numbers', {
        url: '/blocked-numbers',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'blockedNumbers'"><blocked-numbers-tabs></blocked-numbers-tabs></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'NumberPool',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.numberpools', {
        url: '/numberpools',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'numberPools'"><vue-number-pools-list></vue-number-pools-list></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'NumberPool',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.numberpools.edit', {
        url: '/edit/:numberPoolId',
        template: `<vue-redirect-to-v3 flag="'numberPools'"><vue-number-pools-list></vue-number-pools-list></vue-redirect-to-v3>`,
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'NumberPool',
            permission: 'READ',
          },
        },
      })

      .state('dashboard.targets', {
        url: '/targets',
        views: {
          'main@dashboard': {
            template: '<tr-targets></tr-targets>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.target', {
        url: '/target',
        abstract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.target.new', {
        url: '/:targetId',
        template: '<tr-targets></tr-targets>',
        data: {
          permission: {
            type: 'Target',
            permission: 'CREATE'
          }
        },
        params: {
          targetId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.target.clone', {
        url: '/clone/:sourceTargetId',
        template: '<tr-targets></tr-targets>',
        data: {
          permission: {
            type: 'Target',
            permission: 'CREATE'
          }
        },
        params: {
          sourceTargetId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.target.edit', {
        url: '/edit/:targetId',
        template: '<tr-targets></tr-targets>',
        data: {
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.targetgroups', {
        url: '/targetgroups',
        views: {
          'main@dashboard': {
            template: '<tr-target-groups></tr-target-groups>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'TargetGroup',
            permission: 'CREATE' //TODO: On sidebar.view.html this is CREATE, but should it be READ?
          }
        }
      })

      .state('dashboard.targetgroup', {
        url: '/targetgroup',
        abstract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'TargetGroup',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.targetgroup.new', {
        url: '/:targetGroupId',
        template: '<tr-target-groups></tr-target-groups>',
        data: {
          permission: {
            type: 'TargetGroup',
            permission: 'CREATE'
          }
        },
        params: {
          targetGroupId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.targetgroup.edit', {
        url: '/edit/:targetGroupId',
        template: '<tr-target-groups></tr-target-groups>',
        data: {
          permission: {
            type: 'TargetGroup',
            permission: 'UPDATE'
          }
        }
      })

      .state('dashboard.ringtrees', {
        url: '/ringtrees',
        views: {
          'main@dashboard': {
            template: '<ring-trees/>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'PingTree',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.ringtree', {
        url: '/ringtree',
        abstract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'PingTree',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.ringtree.new', {
        url: '/:pingTreeId',
        template: '<ring-trees/>',
        data: {
          permission: {
            type: 'PingTree',
            permission: 'CREATE'
          }
        },
        params: {
          pingTreeId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.ringtree.edit', {
        url: '/edit/:pingTreeId',
        template: '<ring-trees/>',
        data: {
          permission: {
            type: 'PingTree',
            permission: 'UPDATE'
          }
        }
      })

      .state('dashboard.ringtreetargetdashboard', {
        url: '/ringtreetargets/summary',
        views: {
          'main@dashboard': {
            template: '<ring-tree-target-dashboard></ring-tree-target-dashboard>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })


      .state('dashboard.ringtreetargets', {
        url: '/ringtreetargets',
        views: {
          'main@dashboard': {
            template: '<tr-ping-tree-targets></tr-ping-tree-targets>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.ringtreetarget', {
        url: '/ringtreetarget',
        abstract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.ringtreetarget.new', {
        url: '/:pingTreeTargetId',
        template: '<tr-ping-tree-targets></tr-ping-tree-targets>',
        data: {
          permission: {
            type: 'PingTreeTarget',
            permission: 'CREATE'
          }
        },
        params: {
          pingTreeTargetId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.ringtreetarget.clone', {
        url: '/clone/:sourcePingTreeTargetId',
        template: '<tr-ping-tree-targets></tr-ping-tree-targets>',
        data: {
          permission: {
            type: 'PingTreeTarget',
            permission: 'CREATE'
          }
        },
        params: {
          sourcePingTreeTargetId: {
            dynamic: true,
            value: null,
            squash: true
          }
        }
      })

      .state('dashboard.ringtreetarget.edit', {
        url: '/edit/:pingTreeTargetId',
        template: '<tr-ping-tree-targets></tr-ping-tree-targets>',
        data: {
          permission: {
            type: 'Target',
            permission: 'READ'
          }
        }
      })


      .state('dashboard.buyers', {
        url: '/buyers',
        views: {
          'main@dashboard': {
            template: '<vue-buyers></vue-buyers>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Buyer',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.buyer', {
        url: '/buyer',
        abtsract: true,
        views: {
          'main@dashboard': {
            template: '<div ui-view></div>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Buyer',
            permission: 'UPDATE'
          }
        }
      })

      .state('dashboard.buyer.edit', {
        url: '/:buyerId',
        template: '<vue-buyers></vue-buyers>'
      })

      .state('dashboard.urlparams', {
        url: '/urlparams',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'urlParameters'"><url-parameters></url-parameters></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'UrlParam',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.tasks', {
        url: '/tasks?taskid',
        views: {
          'main@dashboard': {
            template: '<user-tasks></user-tasks>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: { // TODO: Currently show the tasks only to Admins, change to add other roles when functionality is added
            type: 'Admin',
            permission: 'All'
          }
        }
      })

      .state('dashboard.callbacks', {
        url: '/pixels',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'pixels'"><tr-callbacks></tr-callbacks></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.webhooks', {
        url: '/webhooks',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'webhooks'"><webhooks></webhooks></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'WebHook',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.authentications', {
        url: '/authentications',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'authentications'"><vue-auth-connections></vue-auth-connections></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.adplatforms', {
        url: '/platforms?success&oauth&error&name',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'platforms'"><vue-platforms></vue-platforms></vue-redirect-to-v3>`,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Integration',
            permission: 'READ'
          }
        },
        params: {
          success: {
            dynamic: true,
            inherit: false
          },
          oauth: {
            dynamic: true,
            inherit: false
          },
          error: {
            dynamic: true,
            inherit: false
          },
          name: {
            dynamic: true,
            inherit: false
          }
        }
      })

      .state('dashboard.account-users', {
        url: '/users',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'users'"><vue-users /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.account-user-groups', {
        url: '/groups',
        views: {
          'main@dashboard': {
            template: `<vue-redirect-to-v3 flag="'userGroups'"><manage-user-groups /></vue-redirect-to-v3>`
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'Admin',
            permission: 'ALL'
          }
        }
      })

      .state('dashboard.call-plans', {
        url: '/callplans',
        views: {
          'main@dashboard': {
            template: '<call-plans></call-plans>'
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'CallPlan',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.call-plans.edit', {
        url: '/edit/:callPlanId',
        views: {
          'main@dashboard': {
            template: '<call-plans></call-plans>'
          }
        },
        data: {
          permission: {
            type: 'CallPlan',
            permission: 'UPDATE'
          }
        }
      })

      .state('dashboard.call-logs', {
        url: '/call-logs?filterkey&filterdisplay&filtervalue&filterisgroup',
        views: {
          'main@dashboard': {
            templateProvider: callLogsTemplateProvider,
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'CallLog',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.rtb-logs', {
        url: '/rtb-logs',
        views: {
          'main@dashboard': {
            template: '<rtb-logs></rtb-logs>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'CallLog',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.call-logs.create-report', {
        url: '/report/new',
        views: {
          'main@dashboard': {
            templateProvider: callLogsTemplateProvider,
          }
        },
        params: {
          expandFilters: true
        }
      })

      .state('dashboard.call-logs.report', {
        url: '/report/:reportId',
        views: {
          'main@dashboard': {
            templateProvider: callLogsTemplateProvider,
          }
        },
        resolve: {
          __reportSettings: savedReportSettingsResolve
        }
      })

      .state('dashboard.new-call-logs', {
        url: '/calls?filterkey&filtervalue&filterisgroup&reportstart&reportend',
        views: {
          'main@dashboard': {
            template: '<call-log-vue-container></call-log-vue-container>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'CallLog',
            permission: 'READ'
          }
        }
      })

      .state('dashboard.new-call-logs.create-report', {
        url: '/report/new?filterkey&filtervalue&filterisgroup',
        views: {
          'main@dashboard': {
            template: '<call-log-vue-container></call-log-vue-container>',
          }
        },
      })

      .state('dashboard.new-call-logs.report', {
        url: '/report/:reportId?filterkey&filtervalue&filterisgroup',
        views: {
          'main@dashboard': {
            template: '<call-log-vue-container></call-log-vue-container>',
          }
        },
      })

      .state('dashboard.insights', {
        url: '/insights',
        views: {
          'main@dashboard': {
            template: '<insights-vue-container></insights-vue-container>',
          }
        },
        data: {
          requireAuth: true,
          requireAccount: true,
          view: 'auth',
          permission: {
            type: 'CallLog',
            permission: 'READ'
          }
        }
      });

    $urlRouterProvider.when('/dashboard/user-account', '/dashboard/account-details');
    $urlRouterProvider.when('/dashboard/user-billing', '/dashboard/billing-settings');
    $urlRouterProvider.when('/dashboard/user-account-settings', '/dashboard/account-settings');
    $urlRouterProvider.when('/dashboard/prp-settings', '/dashboard/publisher-registration');
    $urlRouterProvider.when('/dashboard/brp-settings', '/dashboard/buyer-registration');
    $urlRouterProvider.when('/dashboard/callbacks', '/dashboard/pixels');
    $urlRouterProvider.when('/dashboard/predictive-routing/edit', '/dashboard/predictive-routing');
    $urlRouterProvider.when('/dashboard/predictive-routing/:configId', '/dashboard/predictive-routing/edit/:configId');
    $urlRouterProvider.otherwise('/dashboard/main');
  });
})();
